import React from 'react';
import PropTypes from 'prop-types';
import SV from 'server-vars';
import root from '../../../global/windowCheck.es';
import {AutoModal} from 'dibs-buyer-layout/src/entries/index';
import style from './followSuggestionModal.scss';

const FAVORITE_TRACKING = require('../../../components/FavoriteCta/trackingData.es');
const favoritePageActions = require('../../../global/actions/favoritePageActions.es');

const PAGE_TYPE = 'SEARCH';
const copy = {
    closeCta: 'No, Thank You',
    cta: 'Yes, Send Updates',
    title: 'Interested in items like these?',
    messageTitle: 'Get updates when there are new listings.',
};

const onCtaClick = context => {
    return () =>
        context.executeAction(favoritePageActions.saveToFavorites, {
            name: SV.get('data.header'),
            page: root.location.pathname + root.location.search,
            type: PAGE_TYPE,
            tracking: FAVORITE_TRACKING.SEARCH.BROWSE_AUTO_MODAL.save,
            authModalOptions: {
                ga: { label: FAVORITE_TRACKING.SEARCH.BROWSE_AUTO_MODAL.general.label },
            },
        });
};

const FollowSuggestionModal = ({ context }) => {
    const message = SV.get('data.header');
    return (
        <AutoModal
            copy={copy}
            onCtaClick={onCtaClick(context)}
            tracking={FAVORITE_TRACKING.SEARCH.BROWSE_AUTO_MODAL.general}
        >
            {copy.messageTitle}
            <div className={style.messageBody}>{message}</div>
        </AutoModal>
    );
};

FollowSuggestionModal.propTypes = {
    context: PropTypes.object,
};

export default FollowSuggestionModal;



// WEBPACK FOOTER //
// ./assets/js/finding/components/FollowSuggestionModal/FollowSuggestionModal.jsx